import React from 'react';

const Pagination = ({
  currentPage = 1,
  totalPages = 5,
  onPageChange,
  showPrevNext = true,
}) => {
  const handlePageClick = (page) => {
    if (page !== currentPage && onPageChange) {
      onPageChange(page);
    }
  };

  const handlePrevClick = () => {
    if (currentPage > 1 && onPageChange) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages && onPageChange) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="flex-center w-100">
      <div className="pagination row-flex-center gap-10">
        {/* 이전 버튼 */}
        {showPrevNext && (
          <button
            className={`pagination_btn pagination_arrow 
            ${
              currentPage <= 1 ? 'off' : ''
            } fs-16 prt-regular pointer flex-center`}
            onClick={handlePrevClick}
            disabled={currentPage <= 1}
          >
            &#8249;
          </button>
        )}

        {/* 페이지 번호들 */}
        {Array.from({ length: totalPages }, (_, index) => {
          const pageNumber = index + 1;
          return (
            <button
              key={pageNumber}
              className={`pagination_btn pagination_number
               ${
                 currentPage === pageNumber ? 'on' : ''
               } fs-16 prt-regular pointer flex-center`}
              onClick={() => handlePageClick(pageNumber)}
            >
              {pageNumber}
            </button>
          );
        })}

        {/* 다음 버튼 */}
        {showPrevNext && (
          <button
            className={`pagination_btn pagination_arrow ${
              currentPage >= totalPages ? 'off' : ''
            } fs-16 prt-regular pointer flex-center`}
            onClick={handleNextClick}
            disabled={currentPage >= totalPages}
          >
            &#8250;
          </button>
        )}
      </div>
    </div>
  );
};

export default Pagination;
